// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bCKU","name":"styles_name__1uE3j","phone":"styles_phone__rIpkr"};